import { GeoFlag, UkFlag } from '../Flags';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useScroll, useSpring } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import logo from '../../images/logo.png';
import placeholderLogo from '../../images/logo-fff.png';
import MobileMenu from '../MobileMenu/MobileMenu';

const Header4 = (props) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { user, logout, isAdmin } = useAuth();
    const [mobailActive, setMobailState] = useState(false);
    const [isSticky, setSticky] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('i18n_language', lng);
        const pathname = location.pathname;
        const nonLangPaths = ['/admin', '/login', '/profile', '/my-projects', '/support'];
        const isNonLangPath = nonLangPaths.some(p => pathname.startsWith(p));
        if (isNonLangPath) {
            window.location.reload();
        } else {
            const pathParts = pathname.split('/');
            pathParts[1] = lng;
            window.location.href = pathParts.join('/');
        }
    };

    const isActive = (path) => {
        const currentPath = location.pathname.split('/').slice(2).join('/');
        if (path === '') return currentPath === '';
        return currentPath === path || currentPath.startsWith(path + '/');
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setMobailState(false);
    }, [i18n.language]);

    return (
        <header id="xb-header-area" className="header-area header-style-three header-transparent">
            <motion.div className="progress-bar-global" style={{ scaleX }} />
            
            <div className={`xb-header stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="header__wrap ul_li_between">
                        <div className="header-logo">
                            <Link onClick={ClickHandler} to={`/${i18n.language}`} title={t('navigation.home') || 'Orbitronix Home'}>
                                <img src={logo} alt="Orbitronix Logo" title="Orbitronix" />
                            </Link>
                        </div>
                        <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
                            <nav className="main-menu collapse navbar-collapse" aria-label="Main Navigation">
                                <ul>
                                    {i18n.language !== 'ka' && (
                                    <li className={`menu-item ${isActive('') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}`} title={t('navigation.home') || 'Home'}>
                                            <span>{t('navigation.home')}</span>
                                        </Link>
                                    </li>
                                    )}

                                    <li className={`menu-item ${isActive('about') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/about`} title={t('navigation.about') || 'About'}>
                                            <span>{t('navigation.about')}</span>
                                        </Link>
                                    </li>

                                    <li className={`menu-item ${isActive('services') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/services`} title={t('navigation.services') || 'Services'}>
                                            <span>{t('navigation.services')}</span>
                                        </Link>
                                    </li>

                                    <li className={`menu-item ${isActive('products') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/products`} title={t('navigation.products') || (i18n.language === 'ka' ? 'პროდუქტები' : 'Products')}>
                                            <span>{t('navigation.products') || (i18n.language === 'ka' ? 'პროდუქტები' : 'Products')}</span>
                                        </Link>
                                    </li>

                                    <li className={`menu-item ${isActive('portfolio') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/portfolio`} title={t('navigation.portfolio') || 'Portfolio'}>
                                            <span>{t('navigation.portfolio')}</span>
                                        </Link>
                                    </li>

                                    {i18n.language !== 'ka' && (
                                    <li className={`menu-item ${isActive('blog') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/blog`} title={t('navigation.blog') || 'Blog'}>
                                            <span>{t('navigation.blog') || 'Blog'}</span>
                                        </Link>
                                    </li>
                                    )}

                                    <li className={`menu-item ${isActive('contact') ? 'active' : ''}`}>
                                        <Link onClick={ClickHandler} to={`/${i18n.language}/contact`} title={t('navigation.contact') || 'Contact'}>
                                            <span>{t('navigation.contact')}</span>
                                        </Link>
                                    </li>

                                    {!user && (
                                        <li className="login-btn-item">
                                            <Link onClick={ClickHandler} to={`/${i18n.language}/login`} className="header-login-btn" title={t('header.login') || 'Login'}>
                                                <i className="fas fa-sign-in-alt"></i>
                                                <span>{t('header.login') || 'Login'}</span>
                                            </Link>
                                        </li>
                                    )}

                                    <li className="language-switcher">
                                        <button 
                                            onClick={() => changeLanguage('en')}
                                            className={i18n.language === 'en' ? 'active' : ''}
                                            aria-label="Switch to English"
                                            title="English"
                                        >
                                            <UkFlag size={20} />
                                        </button>
                                        <button 
                                            onClick={() => changeLanguage('ka')}
                                            className={i18n.language === 'ka' ? 'active' : ''}
                                            aria-label="Switch to Georgian"
                                            title="ქართული"
                                        >
                                            <GeoFlag size={20} />
                                        </button>
                                    </li>

                                    <li className="user-auth-area">
                                        {user ? (
                                            <div className="user-profile-nav" onClick={() => setUserMenuOpen(!userMenuOpen)}>
                                                <div className="user-header-trigger">
                                                    <div className="user-header-avatar">
                                                        <img 
                                                            src={user.profile_picture ? (user.profile_picture.startsWith('http') ? user.profile_picture : (process.env.REACT_APP_API_URL || 'https://orbitronix.ge/api/') + user.profile_picture) : placeholderLogo} 
                                                            alt={user.username || 'User Avatar'} 
                                                            title={user.username || 'User Avatar'}
                                                            className="user-avatar-img"
                                                        />
                                                        <div className="user-status-indicator"></div>
                                                    </div>
                                                    <span className="user-header-name d-none d-md-block">{user.username}</span>
                                                    <i className={`fas fa-chevron-down dropdown-arrow ${userMenuOpen ? 'active' : ''}`}></i>
                                                </div>
                                                
                                                {userMenuOpen && (
                                                    <div className="user-dropdown-modern">
                                                        <div className="user-info-header">
                                                            <div className="user-info-top">
                                                                <img 
                                                                    src={user.profile_picture ? (user.profile_picture.startsWith('http') ? user.profile_picture : (process.env.REACT_APP_API_URL || 'https://orbitronix.ge/api/') + user.profile_picture) : placeholderLogo} 
                                                                    alt={user.username || 'User Avatar'} 
                                                                    title={user.username || 'User Avatar'}
                                                                    className="dropdown-avatar"
                                                                />
                                                                <div className="user-info-text">
                                                                    <span className="user-name">{user.username}</span>
                                                                    <span className="user-role">{t(`roles.${user.role}`) || user.role.replace('_', ' ')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="dropdown-links">
                                                            <button onClick={() => { navigate('/profile'); setUserMenuOpen(false); }}>
                                                                <i className="fas fa-user-circle"></i>
                                                                {t('header.myProfile') || 'My Profile'}
                                                            </button>
                                                            <button onClick={() => { navigate('/my-projects'); setUserMenuOpen(false); }}>
                                                                <i className="fas fa-project-diagram"></i>
                                                                {t('header.myProjects') || 'My Projects'}
                                                            </button>
                                                            <button onClick={() => { navigate('/support'); setUserMenuOpen(false); }}>
                                                                <i className="fas fa-ticket-alt"></i>
                                                                {t('header.support') || 'Support Tickets'}
                                                            </button>
                                                            {isAdmin() && (
                                                                <>
                                                                    <div className="dropdown-divider"></div>
                                                                    <button onClick={() => { navigate('/admin'); setUserMenuOpen(false); }}>
                                                                        <i className="fas fa-tachometer-alt"></i>
                                                                        {t('header.adminPanel') || 'Admin Panel'}
                                                                    </button>
                                                                    <button onClick={() => { navigate('/admin/messages'); setUserMenuOpen(false); }}>
                                                                        <i className="fas fa-envelope-open-text"></i>
                                                                        {t('header.messages') || 'Contact Messages'}
                                                                    </button>
                                                                    <button onClick={() => { navigate('/admin/audits'); setUserMenuOpen(false); }}>
                                                                        <i className="fas fa-clipboard-check"></i>
                                                                        Audit Requests
                                                                    </button>
                                                                </>
                                                            )}
                                                            <div className="dropdown-divider"></div>
                                                            <button className="logout-btn" onClick={() => { logout(); navigate('/'); setUserMenuOpen(false); }}>
                                                                <i className="fas fa-sign-out-alt"></i>
                                                                {t('header.logout') || 'Logout'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </li>
                                </ul>
                            </nav>
                            <div className="xb-header-wrap">
                                <div className={`xb-header-menu ${mobailActive ? "active" : ""}`}>
                                    <div className="xb-header-menu-scroll lenis lenis-smooth">
                                        <div 
                                            className="xb-menu-close xb-hide-xl xb-close" 
                                            onClick={() => setMobailState(!mobailActive)}
                                            role="button"
                                            aria-label="Close mobile menu"
                                            title="Close mobile menu"
                                            tabIndex="0"
                                        ></div>
                                        <div className="xb-logo-mobile xb-hide-xl">
                                            <Link onClick={ClickHandler} to={`/${i18n.language}`} rel="home" title="Orbitronix Home">
                                                <img src={logo} alt="Orbitronix Logo" title="Orbitronix" />
                                            </Link>
                                        </div>

                                        <nav className="xb-header-nav" aria-label="Mobile Navigation">
                                            <MobileMenu />
                                        </nav>
                                    </div>
                                </div>
                                <div className="xb-header-menu-backdrop"></div>
                            </div>
                        </div>
                        <div className="header-bar-mobile side-menu d-xl-none">
                            <button 
                                className="xb-nav-mobile" 
                                onClick={() => setMobailState(!mobailActive)}
                                aria-label="Toggle mobile menu"
                                title="Toggle Navigation Menu"
                            >
                                <i className="far fa-bars"></i>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            <style>{`
                .progress-bar-global {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, #6c5ce7, #a29bfe);
                    transform-origin: 0%;
                    z-index: 9999;
                }
                .user-auth-area {
                    margin-left: 20px;
                    position: relative;
                }
                .user-header-trigger {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    cursor: pointer;
                    padding: 6px 12px;
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 50px;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    transition: all 0.3s ease;
                }
                .user-header-trigger:hover {
                    background: rgba(255, 255, 255, 0.1);
                    border-color: rgba(108, 92, 231, 0.5);
                }
                .user-header-avatar {
                    position: relative;
                    width: 32px;
                    height: 32px;
                }
                .user-avatar-img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid #6c5ce7;
                }
                .user-status-indicator {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 10px;
                    height: 10px;
                    background: #2ecc71;
                    border: 2px solid #1a1a24;
                    border-radius: 50%;
                }
                .user-header-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #fff;
                }
                .dropdown-arrow {
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.5);
                    transition: transform 0.3s ease;
                }
                .dropdown-arrow.active {
                    transform: rotate(180deg);
                }
                .auth-icon {
                    font-size: 20px;
                    color: #fff;
                    transition: 0.3s;
                }
                .auth-icon:hover { color: #6c5ce7; }
                
                .user-profile-nav {
                    position: relative;
                }
                .user-dropdown-modern {
                    position: absolute;
                    top: calc(100% + 15px);
                    right: 0;
                    background: #1a1a24;
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 16px;
                    width: 260px;
                    box-shadow: 0 15px 40px rgba(0,0,0,0.6);
                    z-index: 1000;
                    overflow: hidden;
                    animation: dropdownFadeIn 0.3s ease-out;
                }
                @keyframes dropdownFadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .user-info-header {
                    padding: 20px;
                    background: rgb(8 11 37);
                    border-bottom: 1px solid rgba(255,255,255,0.08);
                }
                .user-info-top {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }
                .dropdown-avatar {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    object-fit: cover;
                }
                .user-info-text {
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                    padding: 2px 0;
                }
                .user-name {
                    font-weight: 700;
                    color: #fff;
                    font-size: 16px;
                    line-height: 1.2;
                }
                .user-role {
                    color: #6c5ce7;
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-top: 4px;
                }
                .dropdown-links {
                    padding: 10px;
                }
                .dropdown-links button {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 15px;
                    color: rgba(255,255,255,0.7);
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.2;
                    border-radius: 10px;
                    transition: all 0.2s;
                    width: 100%;
                    text-align: left;
                    background: none;
                    border: none;
                    cursor: pointer;
                }
                .dropdown-links button i {
                    width: 22px;
                    min-width: 22px;
                    font-size: 15px;
                    text-align: center;
                    color: #6c5ce7;
                    opacity: 0.8;
                    flex-shrink: 0;
                }
                .dropdown-links button:hover {
                    background: rgba(108, 92, 231, 0.1);
                    color: #fff;
                    transform: translateX(5px);
                }
                .logout-btn {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 15px;
                    color: rgba(255,255,255,0.7);
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.2;
                    border-radius: 10px;
                    transition: all 0.2s;
                    width: 100%;
                    text-align: left;
                    background: none;
                    border: none;
                    cursor: pointer;
                }
                .logout-btn i {
                    width: 22px;
                    min-width: 22px;
                    font-size: 15px;
                    text-align: center;
                    color: #6c5ce7;
                    opacity: 0.8;
                    flex-shrink: 0;
                }
                .logout-btn:hover {
                    background: rgba(255, 71, 87, 0.1);
                    color: #ff4757;
                }
                .logout-btn:hover i {
                    color: #ff4757;
                }
                .dropdown-divider {
                    height: 1px;
                    background: rgba(255,255,255,0.08);
                    margin: 8px 0;
                }
                .login-btn-item {
                    margin-left: 10px;
                }
                .header-login-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 18px;
                    background: #6c5ce7;
                    color: #fff;
                    border: 1px solid #6c5ce7;
                    border-radius: 30px;
                    font-size: 13px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;
                }
                .header-login-btn:hover {
                    background: #5a4ad1;
                    color: #fff;
                    border-color: #5a4ad1;
                }
                .header-login-btn i {
                    font-size: 12px;
                    margin-right: 2px;
                }
            `}</style>
        </header>
    );
};

export default Header4;